// extracted by mini-css-extract-plugin
export default {"container":"ServiceCard_container__k4GNM","doctorsSection":"ServiceCard_doctorsSection__yqIN8","actions":"ServiceCard_actions__QMBNz"};